/* GUSTA CUSTOMIZATION: FLASH SALE — one shared campaign clock and variant-safe price presentation */
(function () {
  'use strict';

  var config = window.gustaFlashSaleConfig || {};
  var startAt = config.startAt ? Date.parse(config.startAt) : NaN;
  var endAt = config.endAt ? Date.parse(config.endAt) : NaN;
  var discountPercentage = Number(config.discountPercentage || 0);
  var products = config.products || {};
  var eligibleVariantCount = Object.keys(products).reduce(function (total, handle) {
    var product = products[handle] || {};
    return total + (product.isClearance ? 0 : Number(product.eligibleCount || 0));
  }, 0);
  var hasEligibleProducts = eligibleVariantCount > 0;
  var lastState = null;
  var decorateQueued = false;
  var activeTicker = null;
  var scheduledStartTimer = null;

  function stateAt(now) {
    if (Number.isNaN(endAt)) return 'inactive';
    if (!Number.isNaN(startAt) && now < startAt) return 'scheduled';
    if (now < endAt) return 'active';
    return 'ended';
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function parts(remaining) {
    var totalSeconds = Math.max(0, Math.floor(remaining / 1000));
    return {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60
    };
  }

  function compactText(value) {
    if (value.days > 0) return 'Ends in ' + value.days + 'd ' + value.hours + 'h';
    if (value.hours > 0) return 'Ends in ' + value.hours + 'h ' + value.minutes + 'm';
    return 'Ends in ' + Math.max(1, value.minutes) + 'm';
  }

  function pdpText(value) {
    if (value.days > 0) return 'Ends in ' + value.days + 'd ' + pad(value.hours) + 'h ' + pad(value.minutes) + 'm ' + pad(value.seconds) + 's';
    return 'Ends in ' + pad(value.hours) + 'h ' + pad(value.minutes) + 'm ' + pad(value.seconds) + 's';
  }

  function productHandleFromUrl(url) {
    try {
      var path = new URL(url, window.location.origin).pathname;
      var match = path.match(/\/products\/([^/]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (error) {
      return null;
    }
  }

  function applyCardDestination(card, product) {
    var promotionalUrl = stateAt(Date.now()) === 'active' ? product.preferredVariantUrl : null;

    card.querySelectorAll('a.product-item__image-wrapper, a.product-item__title, .product-item__action-list a.product-item__action-button[href*="/products/"]').forEach(function (link) {
      if (!link.hasAttribute('data-gusta-flash-original-href')) {
        link.setAttribute('data-gusta-flash-original-href', link.getAttribute('href') || '');
      }

      var originalHref = link.getAttribute('data-gusta-flash-original-href');
      link.setAttribute('href', promotionalUrl || originalHref);
    });

    card.querySelectorAll('[data-product-url]').forEach(function (control) {
      if (!control.hasAttribute('data-gusta-flash-original-product-url')) {
        control.setAttribute('data-gusta-flash-original-product-url', control.getAttribute('data-product-url') || '');
      }

      var originalProductUrl = control.getAttribute('data-gusta-flash-original-product-url');
      control.setAttribute('data-product-url', promotionalUrl || originalProductUrl);
    });
  }

  function createPriceNode(modifier, dataAttribute) {
    var node = document.createElement('div');
    node.className = 'gusta-flash-sale-price gusta-flash-sale-price--' + modifier;
    node.setAttribute('data-gusta-flash-active-only', '');
    node.setAttribute(dataAttribute, '');

    var label = document.createElement('span');
    label.className = 'gusta-flash-sale-price__label';

    var price = document.createElement('strong');
    price.className = 'gusta-flash-sale-price__amount';

    node.appendChild(label);
    node.appendChild(price);
    return node;
  }

  function decorateCardPrice(card, product) {
    if (!product.cardSalePrice) return;

    var priceList = card.querySelector('.product-item__price-list') || card.querySelector('.price-list');
    if (!priceList) return;

    var node = card.querySelector('[data-gusta-flash-card-price]');
    if (!node) {
      node = createPriceNode('card', 'data-gusta-flash-card-price');
      priceList.insertAdjacentElement('afterend', node);
    }

    var regular = node.querySelector('[data-gusta-flash-card-regular-price]');
    if (stateAt(Date.now()) === 'active' && product.cardRegularPrice) {
      priceList.hidden = true;

      if (!regular) {
        regular = document.createElement('span');
        regular.className = 'gusta-flash-sale-price__regular price price--compare';
        regular.setAttribute('data-gusta-flash-card-regular-price', '');
        regular.style.flexBasis = '100%';

        var regularLabel = document.createElement('span');
        regularLabel.className = 'visually-hidden';
        regularLabel.textContent = config.labels && config.labels.regularPrice ? config.labels.regularPrice : '';

        var regularAmount = document.createElement('span');
        regularAmount.setAttribute('data-gusta-flash-card-regular-amount', '');

        regular.appendChild(regularLabel);
        regular.appendChild(regularAmount);
        node.insertBefore(regular, node.firstChild);
      }

      var regularAmountNode = regular.querySelector('[data-gusta-flash-card-regular-amount]');
      if (regularAmountNode && regularAmountNode.textContent !== product.cardRegularPrice) {
        regularAmountNode.textContent = product.cardRegularPrice;
      }
    } else {
      priceList.hidden = false;
      if (regular) regular.remove();
    }

    var label = node.querySelector('.gusta-flash-sale-price__label');
    var amount = node.querySelector('.gusta-flash-sale-price__amount');
    var labelText = product.cardSalePriceVaries ? 'Flash Sale from' : 'Flash Sale price';

    if (label && label.textContent !== labelText) label.textContent = labelText;
    if (amount && amount.textContent !== product.cardSalePrice) amount.textContent = product.cardSalePrice;
  }

  function decorateCards() {
    document.querySelectorAll('.product-item').forEach(function (card) {
      var titleLink = card.querySelector('.product-item__title[href*="/products/"]');
      if (!titleLink) return;

      var handle = productHandleFromUrl(titleLink.href);
      var product = handle ? products[handle] : null;
      if (!product || !product.eligibleCount || product.isClearance) return;

      card.classList.add('gusta-flash-sale-card');

      var labelList = card.querySelector('.product-item__label-list');
      if (!labelList) {
        labelList = document.createElement('div');
        labelList.className = 'product-item__label-list';
        card.insertBefore(labelList, card.firstChild);
      }

      if (!labelList.querySelector('[data-gusta-flash-card-badge]')) {
        var badge = document.createElement('span');
        badge.className = 'product-label product-label--flash-sale';
        badge.setAttribute('data-gusta-flash-card-badge', '');
        badge.setAttribute('data-gusta-flash-active-only', '');
        badge.textContent = product.eligibleCount < product.totalVariants ? 'FLASH SALE · SELECTED OPTIONS' : 'FLASH SALE';

        var staffPickBadge = labelList.querySelector('[data-gusta-staff-pick-card-badge]');
        if (staffPickBadge) {
          labelList.insertBefore(badge, staffPickBadge);
        } else {
          labelList.appendChild(badge);
        }
      }

      if (!config.landingPage && !labelList.querySelector('[data-gusta-flash-compact-countdown]')) {
        var timer = document.createElement('span');
        timer.className = 'gusta-flash-sale-card-timer';
        timer.setAttribute('data-gusta-flash-active-only', '');
        timer.setAttribute('data-gusta-flash-compact-countdown', '');
        labelList.appendChild(timer);
      }

      applyCardDestination(card, product);
      decorateCardPrice(card, product);
    });
  }

  function selectedVariantId() {
    var form = document.querySelector('.product-form form[action*="/cart/add"], form.product-form[action*="/cart/add"], form[action*="/cart/add"]');
    if (!form) return null;

    var field = form.querySelector('[name="id"]');
    return field && field.value ? String(field.value) : null;
  }

  function removePdpPrice() {
    document.querySelectorAll('[data-gusta-flash-pdp-price]').forEach(function (node) {
      node.remove();
    });
  }

  function decoratePdpPrice() {
    var handle = productHandleFromUrl(window.location.href);
    var product = handle ? products[handle] : null;

    if (!product || product.isClearance || !product.variants) {
      removePdpPrice();
      return;
    }

    var variantId = selectedVariantId();
    var variant = variantId ? product.variants[variantId] : null;

    if (!variant || !variant.eligible || variant.isClearance || !variant.salePrice) {
      removePdpPrice();
      return;
    }

    var priceList = document.querySelector('.product-form__info-content .price-list');
    if (!priceList) return;

    var host = priceList.parentElement;
    var node = host.querySelector('[data-gusta-flash-pdp-price]');
    if (!node) {
      node = createPriceNode('pdp', 'data-gusta-flash-pdp-price');

      var note = document.createElement('span');
      note.className = 'gusta-flash-sale-price__note';
      node.appendChild(note);
      priceList.insertAdjacentElement('afterend', node);
    }

    var label = node.querySelector('.gusta-flash-sale-price__label');
    var amount = node.querySelector('.gusta-flash-sale-price__amount');
    var noteNode = node.querySelector('.gusta-flash-sale-price__note');
    var noteText = discountPercentage > 0 ? discountPercentage + '% off automatically applied at checkout.' : 'Flash Sale discount automatically applied at checkout.';

    if (label && label.textContent !== 'Flash Sale price') label.textContent = 'Flash Sale price';
    if (amount && amount.textContent !== variant.salePrice) amount.textContent = variant.salePrice;
    if (noteNode && noteNode.textContent !== noteText) noteNode.textContent = noteText;
  }

  function decorateAll() {
    decorateCards();
    decoratePdpPrice();
  }

  function queueDecorate() {
    if (decorateQueued) return;
    decorateQueued = true;
    window.requestAnimationFrame(function () {
      decorateQueued = false;
      decorateAll();
      update();
    });
  }

  function updateLandingPage(state) {
    if (!config.landingPage) return;

    var emptyState = document.querySelector('[data-gusta-flash-empty-state]');
    if (!emptyState) return;

    var emptyWrapper = emptyState.closest('.shopify-section') || emptyState;
    var productsWrapper = emptyWrapper.nextElementSibling;
    var showProducts = state === 'active' && hasEligibleProducts;

    emptyState.hidden = showProducts;
    if (productsWrapper) productsWrapper.hidden = !showProducts;

    if (showProducts) return;

    var reason = !hasEligibleProducts ? 'empty' : state;
    var heading = emptyState.querySelector('[data-gusta-flash-empty-heading]');
    var text = emptyState.querySelector('[data-gusta-flash-empty-text]');
    var headingValue = emptyState.getAttribute('data-' + reason + '-heading') || emptyState.getAttribute('data-empty-heading') || '';
    var textValue = emptyState.getAttribute('data-' + reason + '-text') || emptyState.getAttribute('data-empty-text') || '';

    if (heading) heading.textContent = headingValue;
    if (text) text.textContent = textValue;
  }

  function updateCountdownNodes(now, state) {
    var remaining = Number.isNaN(endAt) ? 0 : endAt - now;
    var value = parts(remaining);

    document.querySelectorAll('[data-gusta-flash-compact-countdown]').forEach(function (node) {
      node.textContent = state === 'active' ? compactText(value) : '';
    });

    document.querySelectorAll('[data-gusta-flash-pdp-countdown]').forEach(function (node) {
      node.textContent = state === 'active' ? pdpText(value) : '';
    });

    document.querySelectorAll('[data-gusta-flash-section]').forEach(function (section) {
      var timer = section.querySelector('[data-gusta-flash-countdown-timer]');
      var ended = section.querySelector('[data-gusta-flash-countdown-ended]');

      if (config.landingPage && (!hasEligibleProducts || state !== 'active')) {
        section.hidden = true;
        return;
      }

      if (state === 'active') {
        section.hidden = false;
        if (timer) timer.hidden = false;
        if (ended) ended.hidden = true;
      } else if (state === 'ended') {
        section.hidden = false;
        if (timer) timer.hidden = true;
        if (ended) ended.hidden = false;
      } else {
        section.hidden = true;
      }

      if (state === 'active') {
        var days = section.querySelector('[data-gusta-flash-days]');
        var hours = section.querySelector('[data-gusta-flash-hours]');
        var minutes = section.querySelector('[data-gusta-flash-minutes]');
        var seconds = section.querySelector('[data-gusta-flash-seconds]');

        if (days) days.textContent = pad(value.days);
        if (hours) hours.textContent = pad(value.hours);
        if (minutes) minutes.textContent = pad(value.minutes);
        if (seconds) seconds.textContent = pad(value.seconds);
      }
    });
  }

  function update() {
    var now = Date.now();
    var state = stateAt(now);

    if (state !== lastState) {
      document.documentElement.setAttribute('data-gusta-flash-sale-state', state);
      lastState = state;
    }

    updateLandingPage(state);
    updateCountdownNodes(now, state);
    return state;
  }

  function stopActiveTicker() {
    if (!activeTicker) return;
    window.clearInterval(activeTicker);
    activeTicker = null;
  }

  function startActiveTicker() {
    if (activeTicker || stateAt(Date.now()) !== 'active') return;

    activeTicker = window.setInterval(function () {
      if (update() !== 'active') {
        decorateCards();
        stopActiveTicker();
      }
    }, 1000);
  }

  function scheduleCampaignStart() {
    if (scheduledStartTimer || Number.isNaN(startAt) || stateAt(Date.now()) !== 'scheduled') return;

    var remaining = Math.max(0, startAt - Date.now());
    var delay = Math.min(remaining, 2147483647);

    scheduledStartTimer = window.setTimeout(function () {
      scheduledStartTimer = null;
      var state = update();

      if (state === 'active') {
        decorateAll();
        startActiveTicker();
      } else if (state === 'scheduled') {
        scheduleCampaignStart();
      }
    }, delay);
  }

  function initialize() {
    decorateAll();
    var state = update();

    if (state === 'active') {
      startActiveTicker();
    } else if (state === 'scheduled') {
      scheduleCampaignStart();
    }

    if (!hasEligibleProducts && !config.landingPage) return;

    document.addEventListener('change', queueDecorate);
    document.addEventListener('variant:changed', queueDecorate);

    if ('MutationObserver' in window) {
      new MutationObserver(queueDecorate).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', queueDecorate);
})();
